import React from "react";
import ReactDOM from "react-dom/client";

import App from "@/app";
import AdminApp from "@/admin/AdminApp";
import "@/index.css";

function resolveRootApp() {
  const pathname = window.location.pathname;

  if (pathname === "/admin" || pathname.startsWith("/admin/")) {
    return <AdminApp />;
  }

  return <App />;
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>{resolveRootApp()}</React.StrictMode>,
);